import Vue from 'vue';
import $ from 'jquery';
import DiagnosisQuestionForm from '@/pc/ts/components/pages/diagnosis/DiagnosisQuestionForm.vue'

Vue.config.errorHandler = e => {
  console.error(e);
}

$(() => {
  new Vue({
    render: h => h(DiagnosisQuestionForm)
  }).$mount('#js-diagnosis-question-form')
})